import { useParams, useNavigate } from "react-router";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { TournamentContextProvider } from "../../context/TournamentContext";
import TournamentLesson from "./Components/TournamentLesson";

export default function TournamentContentPage() {
  const { tournamentId, contentType, contentId } = useParams();

  const navigate = useNavigate();

  if (!tournamentId) return null;

  const validContentType =
    contentType === "Lesson" || contentType === "Experiment" ? contentType : undefined;

  if (!contentId || !validContentType) return null;

  const onContentComplete = () => {
    navigate(buildRoute("Learn.routes.tournaments.routes.details.route", { tournamentId }));
  };

  return (
    <TournamentContextProvider
      tournamentId={tournamentId}
      contentType={validContentType}
      contentId={contentId}
    >
      <div
        className="h-full"
        aria-label="Tournament Lesson Content"
        data-testid="tournament-content-page"
      >
        <TournamentLesson onContentComplete={onContentComplete} />
      </div>
    </TournamentContextProvider>
  );
}
